import axios from "axios";

const TELESERVER_API_URL = process.env.REACT_APP_TELESERVER_API_URL;

export const publicTeleserverApi = axios.create({
  baseURL: TELESERVER_API_URL,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_X_API_KEY_PUBLIC,
  },
});

export interface DemoCallRequest {
  agent_id: string;
  phone_number: string;
  variable_values?: Record<string, string>;
  plan_id?: string;
}

export const publicCallingApi = {
  // baseURL: the teleserver named by the prod status, when prod calls are on
  // Kubernetes; omitted means this build's REACT_APP_TELESERVER_API_URL.
  startDemoCall: async (data: DemoCallRequest, baseURL?: string) => {
    const response = await publicTeleserverApi.post(
      "/api/public/call",
      data,
      baseURL ? { baseURL } : undefined,
    );
    return response.data;
  },
};
